module.exports = __webpack_public_path__ + "static/sbore-mim-f21ecdbf3745ea148d03b5c05a546021.jpg";